<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button v-if="backRole('SM_2')" type="primary" @click="startCreate(1)" size="mini">申请使用/外带印章</el-button>
        <el-button v-if="backRole('SM_3')" type="primary" @click="startCreate(2)" size="mini">申请刻制/销毁印章</el-button>
      </div>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column prop="sealName" label="印章名称">
      </el-table-column>
      <el-table-column prop="applyType" label="申请内容" width="150px">
      </el-table-column>
      <el-table-column prop="applyTime" label="申请时间" width="150px">
      </el-table-column>
      <el-table-column label="审批状态" width="90px">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flowVO.approvals" :status="scope.row.flowVO.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="详情" width="130px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="projectDetail(scope.row.flowVO.applyId, scope.row.applyType)"
            plain>点击查看详情</el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑印章信息" placement="bottom" v-if="scope.row.flowVO.status != '审批通过'">
            <el-button type="primary" class="h1-edit" icon="el-icon-edit" circle @click="getRouterLink(scope.row)">
            </el-button>
          </el-tooltip>
          <!-- 取消审批 -->
          <cancel-flow :flow="scope.row.flowVO" @getLists='getLists'></cancel-flow>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from '@/components/CancelFlow'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import projectInfo from '@/page/user/projectInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.getLists()
    },
    methods: {
      // 编辑印章
      getRouterLink(row) {
        console.log(row)
        switch (row.applyType) {
          case '使用印章':
            this.$router.push({
              path: '/Seal/Create',
              query: {
                applyId: row.flowVO.applyId,
              }
            })
            break;
          case '刻制印章':
            this.$router.push({
              path: '/Seal/Create2',
              query: {
                applyId: row.flowVO.applyId,
              }
            })
            break;
        }
      },

      // 取消印章审批
      cancelSealFlow(row) {
        ajax.post('/gc/project/flow/cancel', {
          flowId: row.flow.id
        }, (res) => {
          this.$message.success("该印章使用申请已取消")
          this.getLists()
        })
      },
      // 显示详情弹窗
      projectDetail(applyId, applyType) {

        let _projectTable = {
          status: true,
          applyId,
          tableType: applyType == '使用印章' ? "0" : "1"
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      startCreate(type) {
        switch (type) {
          case 1:
            this.$router.push("/Seal/Create")
            break;
          case 2:
            this.$router.push("/Seal/Create2")
            break;
        }
      },
      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/user/seal/list', '', (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {

    }
  };
</script>


// WEBPACK FOOTER //
// src/page/user/seallist.vue